import React from 'react';
import { ApolloConsumer } from 'react-apollo';
import { CONSTANTS } from '@tpco/tpco-saturn-types';
import ThomasCampaignEdit from 'views/components/ThomasCampaigns/ThomasCampaignEdit';
import { buildThomasCampaign } from 'services/campaignBuilder';
import ThomasCampaignProductContainer from 'containers/ThomasCampaignProductContainer';
import CampaignEditContainer from 'containers/CampaignEditContainer';
import P3CampaignOptimization from 'views/components/Modal/P3CampaignOptimization';
import CampaignStatusContainer from 'containers/CampaignStatusContainer';
import { inspect } from 'util';
import {
  optimizeP3Campaign,
  refetchAdvertiserPageQueries
} from 'views/components/P3Campaigns/P3CampaignOptimization';
import { toast } from 'react-toastify';
import { canBeOptimized } from 'util/p3Validation';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { buildURL } from 'util/nameHelper';

interface ICampaignsPageEditProps {
  tgrams_id: string;
  campaign_id?: string;
  location?: any;
  match?: any;
  history: any;
}

interface CampaignsPageEditState {
  isNew: boolean;
  isModalOpen: boolean;
}

type CampaignsPageEditProps = RouteComponentProps<{}> & ICampaignsPageEditProps;

class CampaignsPageEdit extends React.Component<CampaignsPageEditProps, CampaignsPageEditState> {
  constructor(props: CampaignsPageEditProps) {
    super(props);
    const hasCampaignId = this.props.match.params.campaignId ? true : false;

    this.state = {
      isNew: !hasCampaignId,
      isModalOpen: false
    };
  }
  saveCampaignOptimization = async (values: any, client: any) => {
    const postMutateFunc = () => toast.success(' Optimized campaign is being made');

    let response = await optimizeP3Campaign(
      client,
      values.campaignId,
      values.startDate,
      values.name,
      refetchAdvertiserPageQueries(values.tgramsId, values.campaignId),
      postMutateFunc
    );
    if (response.data && response.data.saveOptimizeCampaign) {
      toast.info('Redirecting to Optimized Campaign...', {
        autoClose: 2000
      });
      setTimeout(() => {
        this.props.history.push(
          `/advertisers/${values.tgramsId}/campaigns/${response.data.saveOptimizeCampaign}/edit`
        );
      }, 2000);
    }
    {
      console.log('Failed to redirect new optimized campaign', inspect(response, false, 5));
      // toast.error('Fails to optimize this campaign');
    }

    this.onClose();
  };
  toggleOptimizeCampaign = () => {
    const { isModalOpen } = this.state;
    this.setState({
      isModalOpen: !isModalOpen
    });
  };
  onClose = () => this.setState({ isModalOpen: false });
  render() {
    const { tgramsId, campaignId } = this.props.match.params;
    const { isModalOpen } = this.state;
    return (
      <div>
        <ApolloConsumer>
          {client => {
            return (
              <CampaignEditContainer tgramsId={tgramsId} campaignId={campaignId || ''}>
                {({ advertiser, campaign, productFulfillment, products, adServers }) => {
                  if (campaign) {
                    return (
                      <React.Fragment>
                        {isModalOpen ? (
                          // Zero SUm
                          <P3CampaignOptimization
                            isModalOpen={isModalOpen}
                            onClose={this.onClose}
                            campaign={campaign}
                            formTitle={'zero sum'}
                            onSaveZeroSum={this.saveCampaignOptimization}
                            client={client}
                          />
                        ) : null}
                        <h1 className="page-title">
                          {this.state.isNew ? 'Create' : 'Edit'} {advertiser.name} Campaign
                          {campaign.product_id == CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS &&
                          canBeOptimized(
                            campaign.status_id,
                            campaign.start_date,
                            campaign.end_date,
                            productFulfillment ? productFulfillment.opportunity_id : ''
                          ) ? (
                            <div className="p3-edit__optimize_button">
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={this.toggleOptimizeCampaign}
                              >
                                Optimize
                              </button>
                            </div>
                          ) : null}
                        </h1>
                        <CampaignStatusContainer campaignId={campaign.campaign_id}>
                          {({ statusId }) => {
                            campaign.status_id = statusId;

                            return (
                              <ThomasCampaignProductContainer product_id={campaign.product_id}>
                                {({ adServerId }) => {
                                  return (
                                    <ThomasCampaignEdit
                                      isNewCampaign={false}
                                      tgramsId={tgramsId}
                                      companyName={advertiser.name}
                                      adServerId={adServerId}
                                      adServers={adServers}
                                      campaign={campaign}
                                      productFulfillment={productFulfillment}
                                      products={products}
                                      client={client}
                                    />
                                  );
                                }}
                              </ThomasCampaignProductContainer>
                            );
                          }}
                        </CampaignStatusContainer>
                      </React.Fragment>
                    );
                  } else {
                    // if isNew, create a new empty campaign
                    campaign = buildThomasCampaign();
                    return (
                      <React.Fragment>
                        <h1 className="page-title">
                          {this.state.isNew ? 'Create' : 'Edit'} {advertiser.name} Campaign
                        </h1>
                        <ThomasCampaignEdit
                          isNewCampaign={true}
                          tgramsId={tgramsId}
                          companyName={advertiser.name}
                          adServers={adServers}
                          campaign={campaign}
                          productFulfillment={productFulfillment}
                          products={products}
                          client={client}
                        />
                      </React.Fragment>
                    );
                  }
                }}
              </CampaignEditContainer>
            );
          }}
        </ApolloConsumer>
      </div>
    );
  }
}

const routeableCamapaignsPageEdit: any = withRouter(CampaignsPageEdit);

export default routeableCamapaignsPageEdit;
